import React, { useState, useEffect } from 'react';
import { Space, Table, } from 'antd';
import { 
    useGetNonStandardServiceQuery,
    useGetAllCustomerUidQuery,
    useGetBillingInvoiceNamesQuery,
    useGetLogisticsServiceByNameQuery,
} from '../../features/api/apiSlice';
import {
    ProTable,
  } from '@ant-design/pro-components';
import { billingDetailsColumns } from './nonStandardServiceTableItems';
import NonStandardServiceSearchBar from './nonStandardServiceSearchBar';
function NonStandardServicePage() {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchData, setSearchData] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const { data: logisticsService } = useGetLogisticsServiceByNameQuery();
    const { data: customerData, refetch: refetchUid } = useGetAllCustomerUidQuery();
    const { data: billingInvoiceNames } = useGetBillingInvoiceNamesQuery();
    const { data, isLoading, isFetching, refetch } = useGetNonStandardServiceQuery({...searchData, pageSize: pageSize, currentPage: currentPage });
    console.log(data);
    useEffect(() => {
        refetch();
        refetchUid();
    }, [])
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
            setSelectedRows(selectedRows);
        },
        selectedRowKeys,
      };
    return (
        <Space direction="vertical" style={{ width: '100%' }}>
        <NonStandardServiceSearchBar
            logisticsService={logisticsService}
            customerData={customerData}
            billingInvoiceNames={billingInvoiceNames}
            setSearchData={setSearchData}
            setCurrentPage={setCurrentPage}
            setPageSize={setPageSize}
            selectedRows={selectedRows}
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
        />
        <ProTable
            search={false}
            size='small'
            rowKey={record => record.id}
            rowSelection={rowSelection}
            columns={billingDetailsColumns}
            dataSource={data?.results}
            loading={isLoading || isFetching}
            pagination={{
                showSizeChanger: true,
                pageSize: pageSize,
                current: currentPage,
                total: data?.count,
                onChange: (page, pageSize) => {
                    setCurrentPage(page);
                    setPageSize(pageSize);
                },
                onShowSizeChange: (current, size) => {
                    setCurrentPage(current);
                    setPageSize(size);
                },
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            }}
            scroll={{ x: billingDetailsColumns.length * 200 }}
            options={{
                reload: () => refetch(),
            }}
            toolbar={{
                title: ' ',
                search: false,
            }}
        />
        </Space>
    );
}

export default NonStandardServicePage;